import Image from 'app/Components/Shared/Image/image';
// NavBar.js
import React, {useEffect, useCallback} from 'react';
import SelfCareButton from 'app/Components/Block/HeaderMainBlock/Desktop/SelfCareButton';
import NavButton from 'app/Components/Block/HeaderMainBlock/Desktop/NavButton';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';

const NavBar = ({props, setTabsUrlList}) => {
  const {
    headerData: {tabIndex, tabs, navButtonsCurrent, navButtonsNew , hideNavigation},
    context,
    isBusinessNavigation,
  } = props;

  const className = isBusinessNavigation || (tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.isBusinessTab?.value === true) ? 'business' : '';
  const handleTabClick = useCallback((index) => {
    props.setNavItemIndex(index);
  }, [props]);

  return (
    <div className={`${className} header-bottom-menu`}>
      {hideNavigation ?
      <>
        <button className='right-button-selfcare' onClick={() => {prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl, context)}}>
          <Image src={require('../images/home-icon.svg')} alt='home-icon'  className='home-icon' />
          <span>לאזור האישי</span>
        </button>
        <span
          className="img-location"
          onClick={() => {
            handleTabClick(-1);
            prepareSameWindowUrlWithNavigateTo(navigation, context);
          }}>
          <Image src={tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.tabIconDesktop?.expandedValue ? Config.epiBaseUrl + tabs[tabIndex]?.tabIconDesktop?.expandedValue?.url : ''}
            alt={'logo'} />
        </span>
      </>
     :
      <div className="bottom-right-side">
        <div className="bottom-right-side-logo">
          {tabs && (
            <span
              className="img-location"
              onClick={() => {
                handleTabClick(-1);
                prepareSameWindowUrlWithNavigateTo(navigation, context);
              }}>
              {props.transactionData?.generalDetails?.family === 'W' && props.startPage?.siteLogoCellcomEnergy?.value?.url
                ? <Image src={Config.epiBaseUrl + props.startPage.siteLogoCellcomEnergy.value.url} alt={'logo'} />
                 : <Image src={tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.tabIconDesktop?.expandedValue ? Config.epiBaseUrl + tabs[tabIndex]?.tabIconDesktop?.expandedValue?.url : ''} alt={'logo'} />}
            </span>
          )}
        </div>
        <div className="bottom-right-side-items">
          {navButtonsCurrent?.map((item, index) => (
            <NavButton
              key={'navButtonCurrent' + index}
              item={item}
              index={index}
              setTabsUrlList={setTabsUrlList}
              props={props}
            />
          ))}
          {navButtonsNew && <span className={'seperate-small-item'}></span>}
          {navButtonsNew?.map((item, index) => (
            <NavButton
              key={'navButtonNew' + (index + navButtonsCurrent?.length)}
              item={item}
              index={index + navButtonsCurrent?.length}
              setTabsUrlList={setTabsUrlList}
              props={props}
            />
          ))}
        </div>
      </div>
      }
      <SelfCareButton props={props} />
    </div>
  );
};

export default NavBar;
